import { createFileRoute } from '@tanstack/react-router';
import { SignatureTemplatesListPage } from '@/features/preparer/signature-templates/SignatureTemplatesListPage';

export const Route = createFileRoute('/preparer/signature-templates/')({
  component: SignatureTemplatesListPage,
});
